module.exports = __webpack_public_path__ + "static/media/fleetlocate-app-store.23da1aee.png";